import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    height: 70px;
    background-color: #FFFFFF;

    @media screen and (max-width: 700px) {
        height: 60px;
    }
`

export const Left = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: flex-start;
`

export const Right = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: flex-end;
    max-width: 35%;
`

export interface ITitlePros {
    size?: string
}

export const Title = styled.h1<ITitlePros>`
    text-align: center;
    font-size: ${props => props.size || '1.25em'};
    color: #31363B;
    margin: 0px!important;
    padding: 0px!important;
    margin-block: 0px!important;
`

export const Logo = styled.img`
    width: 50px;
    height: 50px;

    @media screen and (max-width: 700px) {
        width: 45px;
        height: 45px;
    }
`

export const PageInfo = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 10px;
`

export const PageSubtitle = styled.h2`
    font-size: 0.75em;
    font-weight: normal;
    color: #949499;
    margin: 0px;
`

export const PageTitle = styled.h1`
    font-size: 1.4em;
    color: #31363B;
    font-weight: bold;
    margin: 0px;

    @media screen and (max-width: 700px) {
        font-size: 1em;
    }
`